export function formatAsPercent(value: number | string): number {
  // the percentage is in decimals, so 0.1111 needs to be converted in 11.11%
  const rate = Number(value) * 100;
  const preciseRate = Math.round(rate * 100) / 100;
  return preciseRate;
}
